import styled from '@emotion/styled'


export const MainSection= styled.div({
  margin: '120px auto',
  width: 1200,
  maxWidth: '100%',
})

export const MainTitleOuter = styled.div({
  margin: '0 0 60px'
})

export const MainTitle = styled.h2({
  fontSize: 48,
  textAlign: 'center',
  margin: '0 0 10px'
})

export const MainDesc = styled.p({
  margin: '0 auto',
  maxWidth: 600,
  textAlign: 'center',
  lineHeight: '24px',
    color: '#515860'
})
export const OfferSection = styled.div({
  background: 'linear-gradient(346.23deg, #EFEBF7 -11.18%, #F1EFF6 5.47%, #F3F1F6 34.76%, #F5F4F5 110.86%, #F5F5F5 139.52%)',
  padding: 24,  
  borderRadius: 20,
})

export const OfferBadge = styled.div({
  background: '#673AB7',
  padding: '8px 12px',  
  borderRadius: 100,
  color: '#fff',
  fontWeight: 500,
  display: 'inline-block',
  fontSize: 13,
  '& svg': {
    marginRight: 8,
    display: 'inline-block',
    verticalAlign: 'middle'
  }
})

export const GridContent = styled.div({
  display: 'grid',
  gridTemplateColumns: 'repeat(1, minmax(0, 1fr))',
  gap: 24,
  marginTop: 40,
  '@media (min-width: 800px)': {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))'
  }
})

export const OfferBox = styled.div({
  border: '1px solid #DEDFE4',
  background: '#fff',
  padding: 24,  
  borderRadius: 20,
})

export const OfferBoxTitleOuter = styled.div({
  position: 'relative',
  marginBottom: 32
})

export const OfferBoxTitle = styled.div({
  fontWeight: 700,
  fontSize: 36,
  '& span': {
    fontSize: 16,
    fontWeight: 600,
    display: 'inline-block',
    verticalAlign: 'middle',
  }
})

export const OfferBoxTitlePrice = styled.div({
  fontSize: 16,
  fontWeight: 600,
  marginTop: 14,
  '& span': {
    opacity: '.5',
    textDecoration: 'line-through'
  },
  '@media (min-width: 1020px)': {
    position: 'absolute',
    right: 0,
    top: 0,
  },

})

export const OfferBoxList = styled.div({
  marginBottom: 32
})

export const OfferBoxListItem = styled.div({
  marginBottom: 16,
  fontSize: 14,
  '& span': {
    fontWeight: 600
  }
})

export const OfferBoxListIcon = styled.div({
  display: 'inline-block',
  verticalAlign: 'middle',
  marginRight: 8
})


export const OfferBoxHighlight = styled.div({
  background: '#F5F5F5',
  borderRadius: 12,
  padding: '18px 16px',
  marginBottom: 32
})

export const OfferBoxBadge = styled.div({
  background: '#098032',
  color: '#fff',
  padding: '6px 8px',
  borderRadius: 6,
  display: 'inline-block',
  marginBottom: 24,
  fontSize: 13,
  fontWeight: 500
})

export const OfferBoxText = styled.div({
  fontSize: 15,
  '& span': {
    fontWeight: 600,
    textDecoration: 'underline',
  }
})
